<template>
  <div class="CropperUpload">
    <div v-for="(item, index) in fileList" :key="index" class="upload-list">
      <template v-if="item.showProgress">
        <el-progress :percentage="item.progress" type="circle" :width="89" />
      </template>
      <template v-else>
        <img :src="item.url">
        <div class="demo-upload-list-cover">
          <i class="el-icon-view" @click="handleView(item)"></i>
          <i v-if="!view" class="el-icon-delete" @click="handleRemove(item)"></i>
        </div>
      </template>
    </div>
    <el-upload v-if='!hide' class="avatar-uploader" action="#" :file-list="fileList" :show-file-list="false" :before-upload="beforeAvatarUpload">
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" :modal="false" width="35%">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import Cropper from './cropper'
export default {
  props: {
    aspectRatio: {
      default: 1.5
    },
    hide: {
      type:Boolean,
      default: false
    },
    value: {
      default: ''
    },
    view: {
      default: false
    },
    config: {
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: '',
      fileData: null,
    }
  },
  computed: {
    newConfig: function () {
      const config = {
        imgMaxLength: 1,
        imgSize: 20,
        aspectRatio: this.aspectRatio
      }
      return { ...config, ...this.config }
    }
  },
  watch: {
    fileList: {
      immediate: true,
      deep: true,
      handler: function (data) {
        this.$emit('input', data.reduce((total, item) => {
          if (item.url) {
            total.push(item.url)
          }
          return total
        }, []).join(','))
      }
    },
    value: {
      immediate: true,
      handler: function (data, old) {
        if (!old && data) {
          this.fileList = data.split(',').map(item => {
            return {
              url: item,
              name: Date.now()
            }
          })
        } else if (!data && old) {
          this.fileList = []
        }
      }
    }
  },
  created() { },
  mounted() { },
  methods: {
    handleView(item) {
      this.dialogVisible = true
      this.dialogImageUrl = item.url
    },
    handleRemove(file) {
      const fileList = this.fileList
      this.fileList.splice(fileList.indexOf(file), 1)
    },
    beforeAvatarUpload(file) {
      const _ = this
      const check = this.fileList.length < _.newConfig.imgMaxLength
      if (!check) {
        this.$message({
          type: 'warning',
          message: `仅限上传${_.newConfig.imgMaxLength}张图片`
        })
        return false
      }
      const size = file.size
      if (size > _.newConfig.imgSize * 1024 * 1024) {
        this.$message({
          type: 'warning',
          message: `文件不得超过${Number(_.newConfig.imgSize).toFixed(3)}M`
        })
        return false
      }

      this.fileList.push({
        name: Date.now(),
        showProgress: true,
        progress: 0,
        url: ''
      })
      const leg = this.fileList.length - 1
      const fileitem = this.fileList[leg]
      Cropper.show({
        file: file,
        aspectRatio: this.aspectRatio,
        success(file) {
          this.fileData = new FormData()
          this.fileData.append('file', file)
          _.$UploadFile.uploadFile(this.fileData).then(({ data }) => {
            if (data.code === 200) {
              fileitem.url = data.result
            } else {
              _.faild()
            }
          }).catch(() => {
            _.faild()
          })
            .finally(() => {
              setTimeout(() => {
                fileitem.showProgress = false
              }, 500)
            })
        },
        cancel() {
          _.faild()
        }
      })
      return false
    },
    faild() {
      this.fileList.pop()
      this.messages('图片上传失败', false)
    }
  }
}
</script>
<style lang='scss' scoped>
.CropperUpload {
  display: flex;
  .upload-list {
    display: inline-block;
    width: 90px;
    height: 90px;
    text-align: center;
    line-height: 90px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
    img {
      width: 100%;
      height: 100%;
    }
    .demo-upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.6);
      i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
      }
    }
    &:hover .demo-upload-list-cover {
      display: block;
    }
  }
  .avatar-uploader {
    >>> .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 90px;
    height: 90px;
    line-height: 90px;
    text-align: center;
    border: 1px dashed #eeeeee;
  }
}
</style>
